import { Injectable } from '@angular/core';
import { NachrichtenApiService } from '../../generated/api/nachrichten/nachrichten.service';
import { Observable } from 'rxjs';
import { NachrichtenSimpleResponse } from '../../generated/api/kreditportalBackendAPI.schemas';
import { VertraegeService } from './vertraege.service';
import { switchMap } from 'rxjs/operators';
import { HttpContext } from '@angular/common/http';
import { CACHE_OPTIONS, disableCache, enableCache } from '../services.module/http-cache.tokens';

@Injectable({ providedIn: 'root' })
export class NachrichtenService {

    constructor(
        private readonly vertraegeService: VertraegeService,
        private readonly nachrichtenApiService: NachrichtenApiService
    ) {
    }

    getPosteingangList(refreshCache = false): Observable<NachrichtenSimpleResponse> {
        return this.vertraegeService.getVertraegeNummernListe().pipe(
            switchMap(vertraegeList => {
                const vsnrs = vertraegeList.map(vertrag => vertrag.vsnrNumerisch);
                const context = new HttpContext().set(
                    CACHE_OPTIONS,
                    refreshCache ? disableCache() : enableCache({ ttlMs: 5_000, staleWhileRevalidate: true })
                );
                return this.nachrichtenApiService.getNachrichtenByVsnrs({ vsnrs }, { context });
            })
        );
    }

}
